import React from 'react';
import PropTypes from 'prop-types';
import OMTwinInput from '../OMTwinInput/OMTwinInput';
import OMFiltersTitle from '../OMFiltersTitle/OMFiltersTitle';
import * as styles from './OMTwinInputRow.scss';

const OMTwinInputRow = ({ label, icon, isMobile, field, minTitle, maxTitle, minPlaceholder,
  maxPlaceholder, checkMaxValue, className, separator }) => (
  <div className={styles.rowWrapper}>
    <OMFiltersTitle label={label} icon={icon} isMobile={isMobile} className={styles.titleWrapper} />

    <OMTwinInput
      field={field}
      checkMaxValue={checkMaxValue}
      className={className}
      minTitle={minTitle}
      maxTitle={maxTitle}
      minPlaceholder={minPlaceholder}
      maxPlaceholder={maxPlaceholder}
      separator={separator}
    />
  </div>
);

OMTwinInputRow.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  isMobile: PropTypes.bool,
  field: PropTypes.object,
  minTitle: PropTypes.string,
  maxTitle: PropTypes.string,
  minPlaceholder: PropTypes.string,
  maxPlaceholder: PropTypes.string,
  checkMaxValue: PropTypes.func,
  className: PropTypes.string,
  separator: PropTypes.string
};

export default OMTwinInputRow;
